export const baseURL = "https://dev.digicean.com/api";
// export const baseURL = "http://localhost:5000/api";
